export var ChatMessageRole;
(function (ChatMessageRole) {
    ChatMessageRole["USER"] = "user";
    ChatMessageRole["ASSISTANT"] = "assistant";
    ChatMessageRole["SYSTEM"] = "system";
    ChatMessageRole["TOOL"] = "tool";
})(ChatMessageRole || (ChatMessageRole = {}));
export var ChatEventAction;
(function (ChatEventAction) {
    ChatEventAction["TOKEN"] = "token";
    ChatEventAction["TOOL_START"] = "tool-start";
    ChatEventAction["TOOL_CALL"] = "tool-call";
    ChatEventAction["TOOL_RESULT"] = "tool-result";
    ChatEventAction["MESSAGE_DONE"] = "message-done";
    ChatEventAction["MESSAGE_UPDATE"] = "message-update";
    ChatEventAction["ERROR"] = "error";
    ChatEventAction["SESSION_CREATE"] = "session-create";
    ChatEventAction["SESSION_UPDATE"] = "session-update";
    ChatEventAction["SESSION_DELETE"] = "session-delete";
    ChatEventAction["USER_MESSAGE"] = "user-message";
    ChatEventAction["AGENT_SWITCH"] = "agent-switch";
    ChatEventAction["FOLLOW_UPS"] = "follow-ups";
})(ChatEventAction || (ChatEventAction = {}));
export var ChatToolCallStatus;
(function (ChatToolCallStatus) {
    ChatToolCallStatus["PENDING"] = "pending";
    ChatToolCallStatus["RUNNING"] = "running";
    ChatToolCallStatus["SUCCESS"] = "success";
    ChatToolCallStatus["ERROR"] = "error";
    ChatToolCallStatus["AWAITING_APPROVAL"] = "awaiting_approval";
    ChatToolCallStatus["AWAITING_INPUT"] = "awaiting_input";
    ChatToolCallStatus["DENIED"] = "denied";
})(ChatToolCallStatus || (ChatToolCallStatus = {}));
export const NC_NEW_SESSION = 'NC_SESSION';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2NoYXQvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFOLElBQVksZUFLWDtBQUxELFdBQVksZUFBZTtJQUN6QixnQ0FBYSxDQUFBO0lBQ2IsMENBQXVCLENBQUE7SUFDdkIsb0NBQWlCLENBQUE7SUFDakIsZ0NBQWEsQ0FBQTtBQUNmLENBQUMsRUFMVyxlQUFlLEtBQWYsZUFBZSxRQUsxQjtBQUVELE1BQU0sQ0FBTixJQUFZLGVBY1g7QUFkRCxXQUFZLGVBQWU7SUFDekIsa0NBQWUsQ0FBQTtJQUNmLDRDQUF5QixDQUFBO0lBQ3pCLDBDQUF1QixDQUFBO0lBQ3ZCLDhDQUEyQixDQUFBO0lBQzNCLGdEQUE2QixDQUFBO0lBQzdCLG9EQUFpQyxDQUFBO0lBQ2pDLGtDQUFlLENBQUE7SUFDZixvREFBaUMsQ0FBQTtJQUNqQyxvREFBaUMsQ0FBQTtJQUNqQyxvREFBaUMsQ0FBQTtJQUNqQyxnREFBNkIsQ0FBQTtJQUM3QixnREFBNkIsQ0FBQTtJQUM3Qiw0Q0FBeUIsQ0FBQTtBQUMzQixDQUFDLEVBZFcsZUFBZSxLQUFmLGVBQWUsUUFjMUI7QUFFRCxNQUFNLENBQU4sSUFBWSxrQkFRWDtBQVJELFdBQVksa0JBQWtCO0lBQzVCLHlDQUFtQixDQUFBO0lBQ25CLHlDQUFtQixDQUFBO0lBQ25CLHlDQUFtQixDQUFBO0lBQ25CLHFDQUFlLENBQUE7SUFDZiw2REFBdUMsQ0FBQTtJQUN2Qyx1REFBaUMsQ0FBQTtJQUNqQyx1Q0FBaUIsQ0FBQTtBQUNuQixDQUFDLEVBUlcsa0JBQWtCLEtBQWxCLGtCQUFrQixRQVE3QjtBQTJGRCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsWUFBWSxDQUFDIn0=